import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Transition as _Transition } from "vue";
const _hoisted_1 = {
    key: 1,
    class: "header"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = {
    key: 0,
    class: "content"
};
const _hoisted_4 = { class: "anchor-bottom" };
const _hoisted_5 = ["src"];
import { ref, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useAppState } from '@/composables/useAppState';
import { useAuth } from '@/composables/useAuth';
import { useCustomer } from '@/composables/useCustomer';
import { useMoves } from '@/composables/useMoves';
import { useContent } from '@/composables/useContent';
import HeaderBlock from './elements/HeaderBlock.vue';
import MGButton from './elements/MGButton.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'MovePage',
    setup(__props) {
        const route = useRoute();
        const router = useRouter();
        const state = useAppState();
        useAuth();
        const { getCustomer } = useCustomer();
        const { getCustomerMove, markCustomerMoveAsSeen, markCustomerMoveAsActioned } = useMoves();
        const { getCmsArticleByKey } = useContent();
        const loading = ref(false);
        async function onLoad() {
            getCustomer();
            getCustomerMove(route.params.id, () => {
                markCustomerMoveAsSeen(route.params.id);
                if (state.customerMove.move.cmsPage) {
                    getCmsArticleByKey(state.customerMove.move.cmsPage, (article) => {
                        state.customerMove.move.cmsPage = article.id;
                    });
                }
            });
        }
        function action(move) {
            loading.value = true;
            markCustomerMoveAsActioned(route.params.id, () => {
                if (move.actionUrl && move.actionUrl != '') {
                    window.location.href = move.actionUrl;
                }
                if (move.websiteUrl && move.websiteUrl != '') {
                    window.location.href = move.websiteUrl;
                }
            });
        }
        function cmsAction(move) {
            loading.value = true;
            markCustomerMoveAsActioned(route.params.id, () => {
                router.replace('/Articles/' + move.cmsPage);
            });
        }
        function appAction(move) {
            loading.value = true;
            markCustomerMoveAsActioned(route.params.id, () => {
                processAction(move.appScreen.toLowerCase());
            });
        }
        function multiActionAppAction(screen) {
            loading.value = true;
            markCustomerMoveAsActioned(route.params.id, () => {
                processAction(screen);
            });
        }
        function processAction(screen) {
            screen = screen.toLowerCase();
            if (screen.includes('/questionnaire')) {
                router.replace('/Questionnaire/' + screen.split('/')[2]);
                return;
            }
            if (screen.includes('/plan')) {
                router.replace('/SpendingPlan');
                return;
            }
            if (screen.includes('/marketplace')) {
                router.replace('/MarketPlace');
                return;
            }
            if (screen.includes('/benefits')) {
                router.replace('/Benefits');
                return;
            }
            else if (screen.includes('/spending')) {
                router.replace('/SpendingAnalysis');
                return;
            }
            else if (screen.includes('/goals')) {
                router.replace('/Goals');
                return;
            }
            else if (screen.includes('/finances')) {
                router.replace('/money');
                return;
            }
            else if (screen.includes('/you')) {
                router.replace('/you');
                return;
            }
            else if (screen.includes('/guide')) {
                router.replace('/guides');
                return;
            }
            else if (screen.includes('/recommendedvouchers')) {
                router.replace('/recommendedvouchers');
                return;
            }
            else if (screen.includes('/shopvouchers')) {
                router.replace('/shopvouchers');
                return;
            }
            else {
                router.replace('/');
            }
        }
        onMounted(() => {
            onLoad();
        });
        return (_ctx, _cache) => {
            const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader");
            const _component_v_chip = _resolveComponent("v-chip");
            const _component_v_col = _resolveComponent("v-col");
            const _component_v_row = _resolveComponent("v-row");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(HeaderBlock, {
                    title: "",
                    border: "0"
                }),
                (!_unref(state).customerMove)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createVNode(_component_v_skeleton_loader, {
                            type: "image",
                            class: "move-skeleton-header"
                        }),
                        _createVNode(_component_v_skeleton_loader, {
                            type: "heading",
                            class: "move-skeleton-item"
                        }),
                        _createVNode(_component_v_skeleton_loader, {
                            type: "paragraph",
                            class: "move-skeleton-item"
                        })
                    ], 64))
                    : _createCommentVNode("", true),
                (_unref(state).customerMove)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        _createElementVNode("img", {
                            src: _unref(state).customerMove.move.backgroundImage
                        }, null, 8, _hoisted_2)
                    ]))
                    : _createCommentVNode("", true),
                _createVNode(_Transition, null, {
                    default: _withCtx(() => [
                        (_unref(state).customerMove)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                _createElementVNode("h1", null, _toDisplayString(_unref(state).customerMove.title), 1),
                                _createElementVNode("p", null, _toDisplayString(_unref(state).customerMove.description), 1),
                                _createElementVNode("p", null, [
                                    (_unref(state).customerMove.isPending)
                                        ? (_openBlock(), _createBlock(_component_v_chip, {
                                            key: 0,
                                            class: "mt-3",
                                            variant: "outlined",
                                            size: "small"
                                        }, {
                                            default: _withCtx(() => _cache[3] || (_cache[3] = [
                                                _createTextVNode("Not started")
                                            ])),
                                            _: 1
                                        }))
                                        : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("div", _hoisted_4, [
                                    _createVNode(_component_v_row, { class: "mt-3" }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_v_col, { class: "v-col-1 timeCol" }, {
                                                default: _withCtx(() => [
                                                    _createElementVNode("img", {
                                                        src: require('@/assets/clock.png')
                                                    }, null, 8, _hoisted_5)
                                                ]),
                                                _: 1
                                            }),
                                            _createVNode(_component_v_col, null, {
                                                default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(_unref(state).customerMove.move.timeToComplete) + " minutes ", 1)
                                                ]),
                                                _: 1
                                            })
                                        ]),
                                        _: 1
                                    }),
                                    (_unref(state).customerMove.move.cmsPage)
                                        ? (_openBlock(), _createBlock(MGButton, {
                                            key: 0,
                                            text: _unref(state).customerMove.move.actionButtonText,
                                            fullWidth: "",
                                            onClick: _cache[0] || (_cache[0] = ($event) => (cmsAction(_unref(state).customerMove.move)))
                                        }, null, 8, ["text"]))
                                        : _createCommentVNode("", true),
                                    (_unref(state).customerMove.move.appScreen)
                                        ? (_openBlock(), _createBlock(MGButton, {
                                            key: 1,
                                            text: _unref(state).customerMove.move.actionButtonText,
                                            fullWidth: "",
                                            onClick: _cache[1] || (_cache[1] = ($event) => (appAction(_unref(state).customerMove.move)))
                                        }, null, 8, ["text"]))
                                        : _createCommentVNode("", true),
                                    (_unref(state).customerMove.move.websiteUrl)
                                        ? (_openBlock(), _createBlock(MGButton, {
                                            key: 2,
                                            text: _unref(state).customerMove.move.actionButtonText,
                                            fullWidth: "",
                                            onClick: _cache[2] || (_cache[2] = ($event) => (action(_unref(state).customerMove.move)))
                                        }, null, 8, ["text"]))
                                        : _createCommentVNode("", true),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).customerMove.move.actions, (a) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                            key: a.id
                                        }, [
                                            (a.cmsPage)
                                                ? (_openBlock(), _createBlock(MGButton, {
                                                    key: 0,
                                                    text: a.cta,
                                                    fullWidth: "",
                                                    onClick: cmsAction
                                                }, null, 8, ["text"]))
                                                : _createCommentVNode("", true),
                                            (a.appScreen)
                                                ? (_openBlock(), _createBlock(MGButton, {
                                                    key: 1,
                                                    text: a.cta,
                                                    fullWidth: "",
                                                    onClick: ($event) => (multiActionAppAction(a.appScreen))
                                                }, null, 8, ["text", "onClick"]))
                                                : _createCommentVNode("", true),
                                            (a.websiteUrl)
                                                ? (_openBlock(), _createBlock(MGButton, {
                                                    key: 2,
                                                    text: a.cta,
                                                    fullWidth: "",
                                                    onClick: action
                                                }, null, 8, ["text"]))
                                                : _createCommentVNode("", true)
                                        ]));
                                    }), 128))
                                ])
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                })
            ], 64));
        };
    }
});
